// extracted by mini-css-extract-plugin
export var about = "about-module--about--16f39";
export var aboutImg = "about-module--about-img--28a61";
export var aboutImgDesc = "about-module--about-img-desc--e9e31";
export var aboutImgName = "about-module--about-img-name--64f87";
export var aboutTitle = "about-module--about-title--0d22c";
export var about__col = "about-module--about__col--45259";
export var about__row = "about-module--about__row--01113";